import { ActionType, CategoryType } from './event';

const tid = process.env.REACT_APP_GA_TID;
const ga4Tid = process.env.REACT_APP_GA4_TID;

export function enableTracker() {
  (window as any)[`ga-disable-${tid}`] = false;
  (window as any)[`ga-disable-${ga4Tid}`] = false;
}

export function sendPageView(path: string) {
  const gtag = (window as any).gtag;
  if (gtag) {
    gtag('config', tid, {
      page_path: path
    });
  }
}

export function sendEvent(
  category: CategoryType,
  action: ActionType,
  label?: string,
  value?: number
) {
  const gtag = (window as any).gtag;
  if (gtag) {
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value
    });
  }
}

export function sendException(description: string, fatal = false) {
  const gtag = (window as any).gtag;
  if (gtag) {
    gtag('event', 'exception', { description, fatal });
  }
}
